import http from './http';

export async function listResource(endpoint, {
  page = 1,
  pageSize = 10,
  search = '',
  sortField,
  sortOrder,
  ...extraParams
} = {}) {
  const params = {
    page,
    pageSize,
    search,
    limit: pageSize,
    offset: (page - 1) * pageSize,
    ...extraParams,
  };

  if (sortField && sortOrder) {
    params.sort = sortField;
    params.order = sortOrder === 'ascend' ? 'asc' : 'desc';
  }

  const res = await http.get(endpoint, { params });
  const items =
    res.data?.data?.items ??
    res.data?.data ??
    res.data?.items ??
    res.data ??
    [];

  const total =
    res.data?.total ??
    res.headers?.['x-total-count'] ??
    items.length;

  return { items, total };
}

